export default class PairingInfoError extends Error {
    constructor(message = '', ...args) {
        super(message, ...args);
    }
}
